import {
  Breadcrumbs,
  BreadcrumbsProps,
} from "design-system/components/primitives/breadcrumbs/breadcrumbs";
import "./article-body.scss";

import cn from "clsx";
import { ReactNode } from "react";
import { LazyComponent } from "design-system/components/system/lazy-component/lazy-component";
import { ArticlePageTopper } from "../article-page";
import { SimpleTheme } from "design-system/utils/theme";
import {
  ArticleFooter,
  ArticleFooterProps,
} from "../article-footer/article-footer";

export interface ArticleBodyProps {
  breadcrumbs?: BreadcrumbsProps;
  topper?: ArticlePageTopper;
  footer?: ArticleFooterProps;
  preFooterContent?: ReactNode;
  children: ReactNode;
  leftRail?: ReactNode;
  leftRailLabel?: string;
  rightRail?: ReactNode;
  rightRailLabel?: string;
  theme?: SimpleTheme;
  useDropCap?: boolean;
}

export function ArticleBody({
  breadcrumbs,
  topper,
  footer,
  preFooterContent,
  children,
  leftRail,
  leftRailLabel,
  rightRail,
  rightRailLabel,
  theme,
  useDropCap = true,
}: ArticleBodyProps) {
  return (
    <main id="skipto-main" tabIndex={-1}>
      {topper && <LazyComponent {...topper} />}
      {breadcrumbs && <Breadcrumbs {...breadcrumbs} theme={theme} />}
      <div className="hbs-article-body" data-theme={theme}>
        <aside
          className="hbs-aside-wrapper hbs-aside-left hbs-aside-full hbs-aside-sharetools"
          aria-label={leftRailLabel}
          aria-hidden={!leftRail}
        >
          {leftRail}
        </aside>
        <div
          className={cn(
            "hbs-article-body__main",
            useDropCap && "hbs-use-dropcap",
            rightRail && "image-body-contained",
            !rightRail && "image-right-contained",
          )}
        >
          {children}
        </div>
        <aside
          className="hbs-aside-wrapper hbs-aside-right"
          aria-label={rightRailLabel}
          aria-hidden={!rightRail}
        >
          {rightRail}
        </aside>
      </div>
      {footer && <ArticleFooter theme={theme} {...footer} />}
      {preFooterContent && (
        <div className="hbs-article__extra-content">
          <div className="hbs-article__extra-content-main">
            <div className="hbs-page-body hbs-article__extra-content-inner">
              {preFooterContent}
            </div>
          </div>
        </div>
      )}
    </main>
  );
}
